<template>
  <div class="body">
    <main id="main" style="">
      <div id="top">
        <img :src="require('/static/img/driver-v3-bg.png')" alt="" />
      </div>
      <div id="bottom">
        <div id="bottomleft">
          <img
            :src="require('/static/img/driver_icon@2x.png')"
            alt=""
            width="120"
            height="120"
            id="chezhu"
            style="padding-top: 40px"
          />
        </div>
        <div id="bottomright">
          <table width="100%" height="" border="0" align="left">
            <tbody>
              <tr>
                <td align="center" valign="middle" class="ios_back" style="">
                  <a
                    @click="weixinTip"
                    href="https://itunes.apple.com/cn/app/ri-ri-shun-kuai-xian-si-ji-ban/id1068089972?mt=8"
                    id="JdownApk"
                  >
                    <img
                      :src="require('/static/img/driver-v3-ios.png')"
                      alt=""
                      id="iphonen2"
                      style="width: 88%"
                    />
                  </a>
                </td>
                <td
                  align="center"
                  valign="middle"
                  class="android_back"
                  style=""
                >
                  <a
                    @click="weixinTip"
                    href="https://mecvpro.oss-cn-beijing.aliyuncs.com/download/rrskx-d-release.apk"
                    id="JdownApk2"
                  >
                    <img
                      :src="require('/static/img/driver-v3-android.png')"
                      alt=""
                      id="android2"
                      style="width: 88%"
                    />
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>

    <div id="JweixinTip" class="zezc_nr" style="display: none">
      <div>
        <img :src="require('/static/img/guide-page-tip.png')" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {
    var phoneWidth = parseInt(window.screen.width);
    var phoneScale = phoneWidth / 640;
    var ua = navigator.userAgent;
    if (/Android (\d+\.\d+)/.test(ua)) {
      var version = parseFloat(RegExp.$1);
      // andriod 2.3
      if (version > 2.3) {
        document.write(
          '<meta name="viewport" content="width=640, minimum-scale = ' +
            phoneScale +
            ", maximum-scale = " +
            phoneScale +
            ', target-densitydpi=device-dpi">'
        );
        // andriod 2.3以上
      } else {
        document.write(
          '<meta name="viewport" content="width=640, target-densitydpi=device-dpi">'
        );
      }
      // 其他系统
    } else {
      document.write(
        '<meta name="viewport" content="width=640, user-scalable=no, target-densitydpi=device-dpi">'
      );
    }
    //微信去掉下方刷新栏
    if (RegExp("MicroMessenger").test(navigator.userAgent)) {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function onBridgeReady() {
          WeixinJSBridge.call("hideToolbar");
        }
      );
    }

    var btn1 = document.getElementById("JdownApk"); //下载一
    this.weixinTip(btn1);

    var btn2 = document.getElementById("JdownApk2"); //下载二
    this.weixinTip(btn2);
  },
  methods: {
    weixinTip(ele) {
      var ua = navigator.userAgent;
      var isWeixin = !!/MicroMessenger/i.test(ua);
      if (isWeixin) {
        window.event ? (window.event.returnValue = false) : e.preventDefault();
        document.getElementById("JweixinTip").style.display = "block";
        document.getElementById("JweixinTip").onclick = function () {
          this.style.display = "none";
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.body {
  background-color: #ffffff;
  font-family: "Microsoft YaHei", STXhei;
  font-size: 100%;
  /*overflow: hidden;*/
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
#main #top {
  width: 100%;
}
img {
  max-width: 100%;
}
#main #mid {
  width: 100%;
  height: 220px;
  padding: 0px;
  display: inline-block;
  background-color: rgba(255, 255, 255, 1);
  margin-top: -4px;
}
#mid #midleft #huozhu {
  padding-left: 1em;
  padding-top: 1.1em;
}
#main #line {
  width: 100%;
  height: 8px;
  background-color: #f5f5f5;
  margin-top: -4px;
  padding: 0;
  border-top: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}
#main #mid #midleft {
  width: 27.2%;
  height: 100%;
  float: left;
  margin: 0 auto;
}

#main #midright {
  width: 72%;
  height: 220px;
  float: right;
}
#main #bottom {
  position: absolute;
  bottom: 0px;
  width: 100%;
  /*height: 200px;*/
  left: 0;
  right: 0;
  margin: 0px auto;
  padding: 20px 0px;
  display: inline-block;
  background-color: rgba(255, 255, 255, 1);
}
#bottom #bottomleft #chezhu {
  padding-left: 1em;
  padding-top: 1.1em;
}

#main #bottom #bottomleft {
  width: 0;
  display: none;
  height: 100%;
  float: left;
  margin: 0 auto;
  text-align: center;
}

#main #bottomright {
  width: 80%;
  margin: 0 10%;
  /*height: 200px;*/
  float: right;
}
#bottomline {
  width: 100%;
  height: 50px;
  background-color: #f5f5f5;
  border-top: 1px solid #e8e8e8;
  margin-top: -4px;
  padding: 0;
}

/* 	#weixin-tip{display:none;position:fixed;left:0;top:0;background:rgba(0,0,0,0.8);filter:alpha(opacity=80);width:100%;height:100%;z-index:100;} #weixin-tip p{text-align:center;margin-top:10%;padding:0 5%;position:relative;} #weixin-tip .close{color:#fff;padding:5px;font:bold 20px/24px simsun;text-shadow:0 1px 0 #ddd;position:absolute;top:0;left:5%;}
 	.zezc_nr{width:640px;filter: alpha(opacity=100); opacity: 1; position:fixed; left:50%; margin-left:-320px; top:-100px; z-index:50; overflow:hidden; min-height:1000px;}*/
.zezc_nr {
  position: absolute;
  width: 100%;
  background: rgba(0, 0, 0, 0.85);
  height: 100%;
  float: right;
  z-index: 99;
  top: 0;
  left: 0;
}
.zezc_nr img {
  width: 66%;
  float: right;
  margin: 2%;
}
</style>